import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('expenses', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('expenses/metrics', { params, ...config }),
  store: (payload = {}, config = {}) => axios.post('expenses', payload, config),
  update: (id, payload = {}, config = {}) => {
    const expenseId = Number(id || 0);

    if (payload instanceof FormData) {
      payload.set('_method', 'PUT');
      return axios.post(`expenses/${expenseId}`, payload, config);
    }

    return axios.put(`expenses/${expenseId}`, payload, config);
  },
  taxPreview: (payload = {}, config = {}) => axios.post('expenses/tax-preview', payload, config),
  show: (id, params = {}, config = {}) => axios.get(`expenses/${id}`, { params, ...config }),
  approve: (id, payload = {}, config = {}) => axios.post(`expenses/${id}/approve`, payload, config),
  pay: (id, payload = {}, config = {}) => axios.post(`expenses/${id}/pay`, payload, config),
  delete: (id, config = {}) => axios.delete(`expenses/${id}`, config),
  clearBySale: (saleId, config = {}) => axios.delete(`expenses/sale/${saleId}/clear`, config),
};
